"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var Subject_1 = require("rxjs/Subject");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var SisDatetimeViewComponent = /** @class */ (function () {
    function SisDatetimeViewComponent(formattingService) {
        this.formattingService = formattingService;
        this.isDateOnly = false;
        this.formattedDate = '';
        this.ngUnsubscribe = new Subject_1.Subject();
    }
    SisDatetimeViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.date) {
            if (this.isDateOnly) {
                this.formattingService.formatDate(this.date.valueOf())
                    .takeUntil(this.ngUnsubscribe)
                    .subscribe(function (date) { return _this.formattedDate = date; }, console.error);
            }
            else {
                this.formattingService.formatDateTime(this.date.valueOf())
                    .takeUntil(this.ngUnsubscribe)
                    .subscribe(function (date) { return _this.formattedDate = date; }, console.error);
            }
        }
    };
    SisDatetimeViewComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SisDatetimeViewComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-portfolio-datetime-view',
                    template: "\n               <span>{{formattedDate}}</span>\n             ",
                },] },
    ];
    /** @nocollapse */
    SisDatetimeViewComponent.ctorParameters = function () { return [
        { type: idm_frontend_shared_1.FormattingService, },
    ]; };
    SisDatetimeViewComponent.propDecorators = {
        "id": [{ type: core_1.Input },],
        "date": [{ type: core_1.Input },],
        "isDateOnly": [{ type: core_1.Input },],
    };
    SisDatetimeViewComponent = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n                    <sis-datetime-view [date]=\"%{date}\" %{#isDateOnly} [isDateOnly]=\"%{isDateOnly}\" %{/isDateOnly}>\n                    </sis-datetime-view>",
        }),
        __metadata("design:paramtypes", [idm_frontend_shared_1.FormattingService])
    ], SisDatetimeViewComponent);
    return SisDatetimeViewComponent;
}());
exports.SisDatetimeViewComponent = SisDatetimeViewComponent;
//# sourceMappingURL=sis-datetime-view.component.js.map